import type { AnalyticQuestionGroup } from 'modules/enps/store/models/AnalyticResult'

export const isPromoterScore = (score: number) => score == 9 || score == 10

export const isDetractorScore = (score: number) => score >= 0 && score <= 6

export const getRespondentsTypeCount = (
  actualQuestionsGroup: AnalyticQuestionGroup[] | undefined
) => {
  let promoters = 0,
    detractors = 0

  if (actualQuestionsGroup) {
    actualQuestionsGroup.map((question: AnalyticQuestionGroup) => {
      const answer: (string | number)[] = Object.values(question.answers)

      answer.forEach((response) => {
        if (typeof response === 'number') {
          if (isPromoterScore(response)) promoters += 1
          if (isDetractorScore(response)) detractors += 1
        }
      })
    })
  }

  return {
    promoters,
    detractors,
  }
}
